module.exports = __webpack_public_path__ + "static/img/02344_8.97712a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02344_8.jpg
// module id = PU2V
// module chunks = 1